module.exports = __webpack_public_path__ + "img/cook.be5030ca.webp";